import * as actionType from "./Action_Type";
import { CALL_API } from "../Middlewares/api";
import { sortList } from "../Utils/Sorting";
import * as SGUri from "../Utils/PagesSwitch.js";
import {
  TABLE_GET_LIST,
  TABLE_ADD_MODIFY,
  TABLE_GET_VALUES,
  TABLE_ADD_MODIFY_VALUE
} from "../Utils/Strings/Service_Endpoint";
import { refreshList, requestList } from "./Action_Utils.js";
import { LABEL_Required } from "../Utils/Strings/Labels";
import Moment from "react-moment";
import momentformat from "moment";

export function getTabelleList(filter) {
  var obj = {
    Nome: filter.Nome,
    Descrizione: filter.Descrizione,
    Cancellata: filter.Cancellata,
    IDHolding: filter.IDHolding
  };
  return {
    [CALL_API]: {
      endpoint: TABLE_GET_LIST + SGUri.serializeParameters(obj),
      authenticated: true,
      types: [
        actionType.SERVICE_TABELLE_LIST_REQUEST,
        actionType.SERVICE_TABELLE_LIST_SUCCESS,
        actionType.SERVICE_TABELLE_LIST_ERROR
      ]
    }
  };
}

export const orderListaTabelle = (holdList, value) => {
  return dispatch => {
    dispatch(requestList(actionType.SERVICE_TABELLE_LIST_REQUEST));
    dispatch(
      refreshList(
        sortList(holdList, value),
        actionType.SERVICE_TABELLE_REFRESH_LIST
      )
    );
  };
};

export function setTabella(campo) {
  var obj = {
    ID: campo.ID,
    Nome: campo.Nome,
    Descrizione: campo.Descrizione,
    Holding: campo.Holding,
    Cancellata: campo.Cancellata,
    IDMaster: campo.IDMaster
  };

  return {
    [CALL_API]: {
      endpoint: TABLE_ADD_MODIFY,
      authenticated: true,
      types: [
        actionType.SERVICE_TABELLE_SET_REQUEST,
        actionType.SERVICE_TABELLE_SET_SUCCESS,
        actionType.SERVICE_TABELLE_SET_ERROR
      ],
      method: "POST",
      data: SGUri.serializeParametersPOST(obj)
    }
  };
}

export function setValoreCampoTabella(campo) {
  return {
    [CALL_API]: {
      endpoint: TABLE_ADD_MODIFY_VALUE,
      authenticated: true,
      types: [
        actionType.SERVICE_TABELLE_SET_VALUE_REQUEST,
        actionType.SERVICE_TABELLE_SET_VALUE_SUCCESS,
        actionType.SERVICE_TABELLE_SET_VALUE_ERROR
      ],
      method: "POST",
      data: campo
    }
  };
}

export function getValoriTabella(campo) {
  
  var obj = {
    IDHolding: campo.IDHolding,
    IDTabella: campo.IDTabella,
    Cancellato : false
  };

  return {
    [CALL_API]: {
      endpoint: TABLE_GET_VALUES + SGUri.serializeParameters(obj),
      authenticated: true,
      types: [
        actionType.SERVICE_TABELLE_GET_VALUES_REQUEST,
        actionType.SERVICE_TABELLE_GET_VALUES_SUCCESS,
        actionType.SERVICE_TABELLE_GET_VALUES_ERROR
      ]
    }
  };
}

export function getValoriColonnaTabella(campo) {
  var obj = {
    IDHolding: campo.IDHolding,
    IDTabella: campo.IDTabella,
    IDCampoPersonalizzato: campo.IDColonna
  };

  return {
    [CALL_API]: {
      endpoint: TABLE_GET_VALUES + SGUri.serializeParameters(obj),
      authenticated: true,
      types: [
        actionType.SERVICE_TABELLE_GET_COLUMN_VALUES_REQUEST,
        actionType.SERVICE_TABELLE_GET_COLUMN_VALUES_SUCCESS,
        actionType.SERVICE_TABELLE_GET_COLUMN_VALUES_ERROR
      ]
    }
  };
}

/*
*
* OPERAZIONI SULLA TABELLA NELLA PAGINA CAMPI PERSONALIZZATI
*
*/
const _findIndexOfField = (campiTabellaList, IDCampo, numeroRiga) => {
  var index = -1;
  for (var i = 0; i < campiTabellaList.length; i++) {
    var tmp = campiTabellaList[i];
    if ( tmp.CampoPersonalizzato.ID === IDCampo && tmp.NumeroRiga === numeroRiga ){
      index = i;
      break;
    }
  }
  return index;
}

export function closeFillTable() {
  return dispatch => {
    dispatch({ type: actionType.SERVICE_TABELLE_CLOSE_FILL_TABLE });
  };
}

export const handleOnTableValueChange = ( campiTabellaList, value, campo, numeroRiga ) => {
  var index = _findIndexOfField(campiTabellaList, campo.IDMaster, numeroRiga);
  var valoreP = null;

  if (index == -1) {
    valoreP = {
      Varchar: null,
      Integer: null,
      Boolean: null,
      Decimal: null,
      DateTime: null,
      Cancellato: false,
      Holding: campo.Holding,
      CampoPersonalizzato: {
        ID        : campo.IDMaster,
        Nome      : campo.Nome,
        TipoCampo : campo.TipoCampo
      },
      NumeroRiga: numeroRiga,
      Tabella: {
        ID: campo.IDTabella,
        Nome: null
      }
    };
  } else {
    valoreP = campiTabellaList[index];
  }

  switch (valoreP.CampoPersonalizzato.TipoCampo.ID) {
      case 1: //VARCHAR
              valoreP.Varchar = value || campo.ValoreDefault;
              //Verifico il valore
              if(value == null && campo.Obbligatorio) valoreP.Error = LABEL_Required;
        break;
      case 2: valoreP.Integer = parseInt(value) || campo.ValoreDefault;
        break;
      case 3: 
              if(typeof value === "boolean"){
                valoreP.Boolean = value;
              }else if(typeof value === "string"){
                valoreP.Boolean = (value && (value === "true" || value === "vero") ) || campo.ValoreDefault;
              }else{
                valoreP.Boolean = campo.ValoreDefault || false;
              }
        break;
      case 4: valoreP.Decimal = parseFloat(value) || campo.ValoreDefault;
        break;
      case 5: 
          var date = new Date(value);
          valoreP.DateTime = momentformat(date).format("YYYY-MM-DDTHH:mm:ss") || campo.ValoreDefault;
        break;
      default:valoreP.Varchar = value || campo.ValoreDefault;
    }

  if (index == -1){
    campiTabellaList.push(valoreP);
    index = campiTabellaList.length - 1;
  }

  return dispatch => {
    dispatch({
      type: actionType.SERVICE_TABELLE_REFRESH_TABLEVALUE,
      newList: campiTabellaList,
      index: index
    });
  };
};

/* DELETE TABLE ROW */
export const onDeleteFieldsRow = (campiTabellaList, rowNumber) =>{
    var indexs = [];
    var newList = [];
    campiTabellaList.forEach( ( item, index ) => {
        if( item.NumeroRiga === rowNumber ){
          item.Cancellato = true;
          indexs.push(index);
        }
        newList.push(JSON.parse(JSON.stringify(item)));
      }
    );

    console.log("nuova Lista", newList)
    return dispatch => {
      dispatch({
        type    : actionType.SERVICE_TABELLE_REFRESH_TABLEVALUE,
        newList : newList,
        index   : indexs
      });
    };
}


// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_Tabelle.js